export interface DevOptions {
  devMode: boolean;
  /** If true, toasts will not dismiss automatically. */
  stickyToasts: boolean;
  /** If true, error toast will not be thrown. */
  silentErrors: boolean;
  /** If true, the status page script is not initialised. */
  disableStatusPage: boolean;
  /** If true, virtual service banner will be hidden */
  hideStartMockingBanner: boolean;
  /** If true user can change location for the virtual service any time */
  enableLocationChange?: boolean;
  /** If true, the Admin section in the top menu is shown. */
  enableAdminSection?: boolean;
  /** If true, blueprint management features are enabled (edit button, create from service — admin only). */
  enableBlueprintEdit?: boolean;
}

export const DEV_OPTIONS = 'devOptions';

/**
 * Loads dev options item from local storage. This is useful for changing standard behaviour of UI.
 */
export const loadDevOptions = (): DevOptions | undefined => {
  let devOptions: DevOptions | undefined;
  try {
    devOptions = localStorage.getItem(DEV_OPTIONS) ? JSON.parse(localStorage.getItem(DEV_OPTIONS) as any) : null;
  } catch (error) {
    console.debug('Unable to load devOptions from local storage', error);
  }

  return devOptions;
};

/** Saves dev options */
export const saveDevOptions = (devOptions: DevOptions): void => {
  try {
    localStorage.setItem(DEV_OPTIONS, JSON.stringify(devOptions));
  } catch (error) {
    console.debug('Unable to load devOptions from local storage', error);
  }
};
